module.exports = __webpack_public_path__ + "img/H2.45b7fd5e.png";